import type { JobStatus, SubmissionStatus, ProductStatus } from '../../types'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'blue' | 'green' | 'gold' | 'red' | 'gray'
  status?: string
}

export function Badge({ children, variant, status }: BadgeProps) {
  const className = status
    ? `badge status-${status.toLowerCase().replace('_', '-')}`
    : `badge badge-${variant || 'gray'}`

  return <span className={className}>{children}</span>
}

export function getStatusBadge(status: JobStatus | SubmissionStatus | ProductStatus): { variant: string; label: string } {
  const statusMap: Record<string, { variant: string; label: string }> = {
    // Job statuses
    PENDING_REVIEW: { variant: 'pending-review', label: 'Taken Down' },
    OPEN: { variant: 'open', label: 'Open' },
    APPLIED: { variant: 'in-progress', label: 'Applied' },
    IN_PROGRESS: { variant: 'in-progress', label: 'In Progress' },
    REVIEW: { variant: 'review', label: 'In Review' },
    COMPLETED: { variant: 'completed', label: 'Completed' },
    CANCELLED: { variant: 'cancelled', label: 'Cancelled' },
    // Submission statuses
    PENDING: { variant: 'in-progress', label: 'Pending' },
    APPROVED: { variant: 'completed', label: 'Approved' },
    REJECTED: { variant: 'cancelled', label: 'Rejected' },
    REVISION_REQUESTED: { variant: 'review', label: 'Revision' },
    // Product statuses
    DRAFT: { variant: 'gray', label: 'Draft' },
    DELISTED: { variant: 'cancelled', label: 'Delisted' },
  }

  return statusMap[status] || { variant: 'gray', label: status }
}
